import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import { authCardSurfaceSx } from '@/theme/designTokens'

interface AuthCardProps {
  readonly children: ReactNode
  readonly maxWidth?: number
}

export function AuthCard({ children, maxWidth = 464 }: AuthCardProps) {
  return (
    <Box
      sx={{
        ...authCardSurfaceSx,
        width: '100%',
        maxWidth,
        borderRadius: '16px',
        boxShadow:
          '0px 10px 15px 0px rgba(0,0,0,0.1), 0px 4px 6px 0px rgba(0,0,0,0.1)',
        pt: { xs: '24px', sm: '29px' },
        pb: { xs: '24px', sm: '33px' },
        px: { xs: '16px', sm: '32px' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  )
}
